import type { CardRefundDoc, CardRefundQueueState } from "@/firestore/cardRefunds";
import type { QuerySpec } from "@/firestore/hooks";

export const REFUND_STATE_LABELS: Record<CardRefundQueueState, string> = {
  awaitingProvider: "Awaiting provider",
  toPay: "To pay",
  authorizing: "Preparing payout instructions",
  assigned: "Assigned",
  releasing: "Releasing assignment",
  verifying: "Verifying transfer",
  done: "Done",
  cancelled: "Cancelled",
  needsReview: "Needs review",
};

export type RefundFilter = "toPay" | "mine" | "inProgress" | "done" | "needsReview" | "all";

export function refundQuery(filter: RefundFilter, backendId: string): QuerySpec {
  return {
    filters:
      filter === "all"
        ? []
        : filter === "mine"
          ? [["claimedBy", "==", backendId]]
          : filter === "inProgress"
            ? [["queueState", "in", ["authorizing", "assigned", "releasing", "verifying"]]]
            : [["queueState", "==", filter]],
    orderBy: [["createdAt", "asc"]],
  };
}

export function refundMerchant(refund: Pick<CardRefundDoc, "merchantName">): string {
  return refund.merchantName?.trim() || "Card refund";
}

/** Keep all integer precision when operators copy a transfer amount. */
export function refundTransferAmount(micro: number): string {
  if (!Number.isSafeInteger(micro) || micro <= 0) return "";
  const amount = BigInt(micro);
  const fraction = (amount % 1_000_000n).toString().padStart(6, "0").replace(/0+$/, "");
  return `${amount / 1_000_000n}${fraction ? `.${fraction}` : ""}`;
}

export function validTransferHash(value: string): boolean {
  return /^0x[0-9a-fA-F]{64}$/.test(value.trim());
}

export function validLogIndex(value: string): boolean {
  return value.trim() === "" || (/^\d+$/.test(value) && Number.isSafeInteger(Number(value)));
}

export function refundActionError(error: unknown): string {
  return error instanceof Error ? error.message : "The action could not be recorded.";
}
